import { Card, Button, Modal, Form, Input, Avatar } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  create_article,
  deleteArticle,
  Timeline,
  getinitialData
} from '../../reducers/articlesReducer'

import { DeleteFilled } from '@ant-design/icons'

import Styles from './index.module.css'

const { TextArea } = Input
const { Meta } = Card

const Articles = () => {
  let dispatch = useDispatch()
  const [modalVisible, setModalVisible] = useState(false)
  const [load, loading] = useState(2)
  const [form] = Form.useForm()

  const handleCancel = () => {
    setModalVisible(false)
    form.resetFields()
  }

  const onFinish = (values) => {
    let Article = {
      text: values.articleBody,
      title: values.articleTitle,
      url: values.url
    }
    dispatch(create_article(Article)).then(() => {
      dispatch(getinitialData())
    })
    setModalVisible(false)
    form.resetFields()
  }

  useEffect(() => {
    dispatch(getinitialData())
  }, [dispatch])

  const result = useSelector((state) => state.articles)
  const articleData = result?.articles
  const totalPages = result?.totalPages

  function handleClick() {
    setModalVisible(true)
  }

  const onLoadMore = () => {
    if (load <= totalPages) {
      let t = load
      dispatch(Timeline(t, 5))
      t++
      loading(t)
    }
  }
  const navigate = useNavigate()

  return (
    <>
      <div className={Styles['articles-wrapper']}>
        <div className={Styles['article-title-container']}>
          <h2>Articles</h2>
          <div className={Styles['article-title-container']}>
            <Button
              type="secondary"
              shape="round"
              onClick={() => {
                navigate(`/app/myarticle`)
              }}
            >
              My Articles
            </Button>
            <Button
              shape="round"
              type="secondary"
              onClick={() => {
                navigate(`/app/myBookMarks`)
              }}
            >
              My Bookmarks
            </Button>
            <Button type="primary" shape="round" onClick={handleClick}>
              New Article
            </Button>

            <Modal
              title="Add New Article"
              visible={modalVisible}
              onOk={form.submit}
              onCancel={handleCancel}
              footer={[
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={form.submit}>
                  Submit
                </Button>
              ]}
            >
              <Form
                form={form}
                name="normal_login"
                className="login-form"
                onFinish={onFinish}
              >
                <Form.Item
                  name="articleTitle"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your article title'
                    },
                    {
                      max: 100,
                      message: 'Title cannot exceed 100 characters'
                    }
                  ]}
                >
                  <Input type="text" placeholder="Article title" />
                </Form.Item>
                <Form.Item
                  name="articleBody"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your article body'
                    }
                  ]}
                >
                  <TextArea
                    type="text"
                    placeholder="Article body"
                    autoSize={{ minRows: 5, maxRows: 6 }}
                  />
                </Form.Item>
                <Form.Item name="url">
                  <Input type="text" placeholder="Article url" />
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </div>

        {articleData?.map((article, index) => (
          <ArticleCard key={index} article={article} />
        ))}

        {load <= totalPages ? (
          <span
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Button className={Styles['onLoadMore']} onClick={onLoadMore}>
              Loading more
            </Button>
          </span>
        ) : (
          <div className={Styles['onLoadMore']}>End of results</div>
        )}
      </div>
    </>
  )
}

const ArticleCard = ({ article }) => {
  const navigate = useNavigate()
  let dispatch = useDispatch()

  const clickDelete = (e) => {
    e.stopPropagation()
    Modal.confirm({
      title: 'Are you sure you want to delete?',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => dispatch(deleteArticle(article.id))
    })
  }

  const viewArticle = () => {
    navigate(`/app/articles/${article.id}`)
  }
  const user = useSelector((state) => state.auth.user)

  return (
    <div className={Styles['article-card-container']}>
      <Card hoverable className="article-card" onClick={viewArticle}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Meta
            style={{ alignItems: 'center' }}
            avatar={<Avatar src={article?.authorPersonId?.photo} />}
            title={
              <div style={{ fontWeight: 600, fontSize: '16px' }}>
                {article?.authorPersonId?.name || user.name}
              </div>
            }
          />
          {user?._id ===
            (article?.authorPersonId?._id || article?.authorPersonId) && (
            <Button
              type="icon"
              className={Styles['iconButton']}
              onClick={clickDelete}
            >
              <DeleteFilled />
            </Button>
          )}
        </div>
        <div style={{ fontSize: '16px', marginTop: '10px' }}>
          <b>{article?.title}</b>
        </div>

        <span className={Styles['article-date']}>
          {article?.text.length > 800 ? (
            <>
              {article?.text.slice(0, 800)}
              <span
                style={{
                  color: '#1677ff',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                {' '}
                Read more ...
              </span>
            </>
          ) : (
            article?.text
          )}
        </span>
      </Card>
    </div>
  )
}

export default Articles
